/**
 * Store: Back in stock
 * -----------------------------------------------------------------------------
 * Tracks what product & variant should be displayed in the Back in Stock
 * modal.
 *
 */
export default {
  namespaced: true,

  state: () => ({
    productId: 0,
    variantId: 0,
    variantTitle: '',
  }),

  mutations: {

    /**
     * Set back in stock product id.
     * @param {String} productId - Product id.
     */
    SET_PRODUCT_ID(state, productId) {
      state.productId = productId
    },

    /**
     * Set back in stock variant id.
     * @param {String} variantId - Variant id.
     */
    SET_VARIANT_ID(state, variantId) {
      state.variantId = variantId
    },

    /**
     * Set back in stock variant title.
     * @param {String} variantTitle - Variant title.
     */
    SET_VARIANT_TITLE(state, variantTitle) {
      state.variantTitle = variantTitle
    },
  },

  actions: {

    /**
     * Set back in stock product id.
     * @param {String} productId - Product id.
     */
    setProductData({ commit, dispatch }, {
      productId = 0,
      variantId = 0,
      variantTitle = '',
    } = {}) {
      commit('SET_PRODUCT_ID', productId)
      commit('SET_VARIANT_ID', variantId)
      commit('SET_VARIANT_TITLE', variantTitle)

      /**
       * Open back in stock overlay if setting a id.
       */
      if (!productId || !variantId || !variantTitle) {
        return
      }

      const data = {
        component: 'back-in-stock',
        ignoreDismissed: true,
        namespace: 'backInStock',
      }

      dispatch('overlays/open', data, { root: true })
    },
  },
}
